import React from 'react';
import SVGLoader from './SVGLoader';

const defaults = {
  width: 16,
  height: 16,
  viewboxWidth: 16,
  viewboxHeight: 16,
};

const CheckIcon = ({
  width = defaults.width,
  height = defaults.height,
  viewboxWidth = defaults.viewboxWidth,
  viewboxHeight = defaults.viewboxHeight,
  ...rest
}) => {
  return (
    <SVGLoader
      width={width}
      height={height}
      viewboxWidth={viewboxWidth}
      viewboxHeight={viewboxHeight}
      {...rest}
    >
      <path
        d="M15.4809 2.62792C15.3771 2.52332 15.2537 2.44032 15.1178 2.38365C14.9818 2.32705 14.836 2.29785 14.6887 2.29785C14.5413 2.29785 14.3956 2.32705 14.2596 2.38365C14.1237 2.44032 14.0003 2.52332 13.8965 2.62792L5.58454 10.9511L2.09234 7.44778C1.98467 7.34378 1.85754 7.26192 1.71821 7.20698C1.57894 7.15212 1.43014 7.12525 1.28047 7.12778C1.13074 7.13045 0.983006 7.16252 0.845673 7.22218C0.708406 7.28185 0.584139 7.36798 0.480139 7.47565C0.376073 7.58332 0.294339 7.71052 0.239406 7.84978C0.184539 7.98912 0.157606 8.13785 0.160206 8.28759C0.162739 8.43732 0.194806 8.58499 0.254473 8.72225C0.314206 8.85959 0.400339 8.98385 0.508006 9.08785L4.79234 13.3722C4.89607 13.4767 5.01947 13.5598 5.15541 13.6165C5.29141 13.6731 5.43721 13.7023 5.58447 13.7023C5.73181 13.7023 5.87761 13.6731 6.01361 13.6165C6.14947 13.5597 6.27287 13.4767 6.37667 13.3722L15.4809 4.26798C15.5941 4.16352 15.6845 4.03672 15.7463 3.89558C15.8081 3.75445 15.84 3.60205 15.84 3.44792C15.84 3.29378 15.8081 3.14145 15.7463 3.00032C15.6845 2.85918 15.5941 2.73238 15.4809 2.62792Z"
        fill="currentColor"
      />
    </SVGLoader>
  );
};

export default CheckIcon;
